import { rsimSubscriptionStatusFilterAtom } from 'src/atoms/filters/rsim-products';
import { SubscriptionStatusChips } from 'src/common/components/FilterChip/SubscriptionStatusChips';

export const RSimSubscriptionStatusChips = () => {
  return <SubscriptionStatusChips subscriptionStatusAtom={rsimSubscriptionStatusFilterAtom} />;
};
